import React from 'react';
import styles from './Icons.scss';
import cn from 'classnames';
import { IconProps, Icons } from './IconsRes';
import { getIconClasses } from '@/Static/IconUtils';

export const EditIcon = ({ id, onClick, size = 'small', disabled, className }: IconProps) => {
  return (
    <img
      id={id}
      src={Icons.Edit}
      alt="img"
      className={cn(styles.icon, className, getIconClasses(size, disabled))}
      onClick={() => {
        if (!disabled) onClick?.();
      }}
    />
  );
};
